import { render, staticRenderFns } from "./dialog-select-insurance.vue?vue&type=template&id=70ef5a29&"
import script from "./dialog-select-insurance.vue?vue&type=script&lang=ts&"
export * from "./dialog-select-insurance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports